// components/sar/DetectionLegend.jsx
import React, { useState } from 'react';
import { siteColorList } from '../../utils/SarSiteColors';
import './DetectionLegend.css'


function InfoTooltip({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="info-tooltip-wrapper">
      <button type="button" className="info-tooltip-trigger"
        onClick={() => setOpen(o => !o)} onBlur={() => setOpen(false)}
        aria-label="What does this mean?">ⓘ</button>
      {open && <div className="info-tooltip-content">{children}</div>}
    </span>
  );
}

export function DetectionLegend({ 
  showUnconfirmed, 
  onToggle,
  unconfirmedCount, 
  totalCount, 
  siteNameMap 
}) {

const sites = siteColorList();
const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="detection-legend">
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <label className="ais-checkbox-label">
          <input
            type="checkbox"
            checked={showUnconfirmed}
            onChange={(e) => onToggle(e.target.checked)}
          />
          <span className="ais-custom-checkbox" />

          <span className="ais-checkbox-text">
            {/* Show unconfirmed AIS detections ({unconfirmedCount} of {totalCount}) */}
            Show unconfirmed AIS detections
          </span>

          <button
            onClick={() => setShowPopup(!showPopup)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: '0.25rem',
            }}
          >
            <svg
              width="22"
              height="22"
              fill="#e7dbb9"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M10 1a9 9 0 1 1 0 18A9 9 0 0 1 10 1zm0 2a7 7 0 1 0 0 14A7 7 0 0 0 10 3zm.9 10.5v-5h-1.8v5h1.8zM10 6.5a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8z" />
            </svg>
          </button>
        </label>
        {showPopup && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '0',
              marginTop: '0.8rem',
              backgroundColor: 'rgba(20, 20, 20, 0.9)',
              color: '#e7dbb9',
              padding: '1rem 1.2rem',
              borderRadius: '10px',
              fontFamily: 'Orbitron, sans-serif',
              fontSize: '0.9rem',
              width: '280px',
              boxShadow: '0 0 12px rgba(0,0,0,0.4)',
              zIndex: 999999,
              whiteSpace: 'normal',
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              textAlign: 'left',
            }}
          >
            <span style={{ fontWeight: 700 }}>
              Unconfirmed AIS Detection:
            </span>
            <br />
            Amber markers indicate high-confidence detections where no nearby AIS
            activity was found in Global Fishing Watch&apos;s data.
            <br />
            <br />
            This does <span style={{ fontWeight: 700 }}>not</span> mean the vessel
            isn&apos;t transmitting AIS. GFW&apos;s public coverage has confirmed
            gaps in several corridors, including Hormuz, Malacca, and Bab-el-Mandeb,
            where zero coverage can occur despite real AIS traffic nearby.
            <br />
            <br />
            Treat these detections as{' '}
            <span style={{ fontWeight: 700 }}>
              &quot;worth a second look&quot;
            </span>
            , not confirmation that anything is hidden.
          </div>
        )}
      </div>

      {/* <div className="site-color-legend">
        {sites.map(({ id, color }) => (
          <div className="site-color-row" key={id}>
            <span className="legend-dot" style={{ background: `#${color.getHexString()}` }} />
            <span className="site-color-label">{siteNameMap?.[id] ?? id}</span>
          </div>
        ))}
      </div> */}
    </div>

    
  );
}